import { render, staticRenderFns } from "./Versions.vue?vue&type=template&id=3d7ca3e4&scoped=true&lang=html&"
import script from "./Versions.vue?vue&type=script&lang=js&"
export * from "./Versions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7ca3e4",
  null
  
)

export default component.exports